import BidState from '../BidState';

//TODO: move total calculate function
const taskTotal = (bidTasks) => {
  let subtotal = 0;
  let tax = 0;
  let total = 0;
  bidTasks.forEach((bidTask) => {
      subtotal += bidTask.subtotal;
  });

  tax = Number((subtotal*0.05).toFixed(2));
  total = subtotal + tax;
  return total;
}

export const selectBidMetrics = (store) => {

  const bids = store.bidsState;
  let numberOfDrafts = 0;
  let numberToClose = 0;
  let unsentTotal = 0;
  let sentTotal = 0;
  let numberWon = 0;
  let numberLost = 0;
  let winRatio = 0;

  bids.forEach((bid) => {
    const bidState = new BidState({...bid.state});

    if (bidState.type === "draft") {
      numberOfDrafts += 1;
      let bidTasks = store.bidTasksState.filter( bidTask => bidTask.bidId === bid.id);
      unsentTotal += taskTotal(bidTasks);
    }

    if (bidState.type === "sent" || bidState.type === "overdue") {
      let bidTasks = store.bidTasksState.filter( bidTask => bidTask.bidId === bid.id);
      sentTotal += taskTotal(bidTasks);
    }

    if (["draft", "sent", "overdue"].includes(bidState.type)) {
      numberToClose += 1;
    }

    if (["lost", "cacnelled"].includes(bidState.type)) {
      numberLost += 1;
    }

    numberWon += bidState.type === "won" ? 1 : 0;
    winRatio = (numberWon + numberLost) > 0
      ? (numberWon/(numberLost + numberWon))*100
      : 0;
  });

  return [
    {
      type: "horizontal",
      label: "Bids to finish and send",
      display: numberOfDrafts,
    },
    {
      type: "horizontal",
      label: "Bids to close",
      display: numberToClose,
    },
    {
      type: "vertical",
      label: "unsent",
      display: `$${unsentTotal.toFixed(2)}`,
    },
    {
      type: "vertical",
      label: "client decision overdue",
      display: `$${sentTotal.toFixed(2)}`,
    },
    {
      type: "vertical",
      label: "win ratio",
      display: `${winRatio.toFixed()}%`,
    },
  ];
}



// WEBPACK FOOTER //
// ./src/store/selectors/metrics/bids.js